// extracted by mini-css-extract-plugin
export default {"container":"Images_container__L1iq0","image":"Images_image__F4arf"};